
const servicesData = [
  'hap_dms_server',
  'hap_iportal',
  'hap_xfinityvoice_as',
  'hap_auth_manager',
  'hap_least_load',
  'hap_identity_manager',
  'hap_cloud_code',
  'hap_tnps',
  'hap_dms_portal',
  'hap_event_manager',
  'hap_document_store',
  'hap_iristest_as',
  'hap_notification_manager',
];

export default servicesData;
